import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import palette from '@ui/palette';
import { useLayoutContext } from '../../context/LayoutContext';
import { RIGHT_RAIL_WIDTH, RightRailProps } from '.';

type LayeredRightRailProps = RightRailProps;

const useLayeredStyles = makeStyles()(theme => ({
  root: {
    gridArea: 'right',
    height: '100%',
    overflow: 'hidden',
    transition: theme.transitions.create(['width', 'visibility', 'transform'], {
      easing: 'cubic-bezier(0.25, 0.25, 0.5, 1)',
      duration: 600,
    }),
    visibility: 'hidden',
    position: 'relative',
    transform: `translateX(100%)`,
    zIndex: theme.zIndex.drawer + 2,
    /**
     * @todo - Move this background color declaration to the children being passed
     * Was added here as a quick styling fix
     */
    backgroundColor: palette.gray_1100,
  },
  open: {
    borderLeft: `1px solid ${palette.gray_800}`,
    visibility: 'visible',
    width: RIGHT_RAIL_WIDTH,
    transform: `translateX(-${RIGHT_RAIL_WIDTH}px)`,
    overflowY: 'scroll',
  },
}));

/**
 * @description A layout component for the Right Rail that implements an layered approach to displaying it in the page,
 *  i.e. this rail will layer on top of its siblings
 */
export default function LayeredRightRail({ children }: LayeredRightRailProps) {
  const { classes, cx } = useLayeredStyles();
  const { isRightRailOpen } = useLayoutContext();

  return (
    <Box className={cx(classes.root, isRightRailOpen && classes.open)}>
      {children}
    </Box>
  );
}
